<div class="pageWrapper">
  <div class="list-header">
    <h1>Style Guide Page</h1>
  </div>

  <div class="row">
    <div class="col col-max-w">
      <section id="colors">
        <h3 class="demo-section-title">Colors</h3>
        <h4>Brand colors</h4>
        <div class="row mb-3">
          <div class="col-3">
            <mat-card class="p-3 bg-primary">
              <h4>Primary</h4>
              $brand-primary
            </mat-card>
          </div>
          <div class="col-3">
            <mat-card class="p-3 bg-secondary">
              <h4>Secondary</h4>
              $brand-secondary
            </mat-card>
          </div>
        </div>
        <h4>Neutral colors</h4>
        <div class="row mb-3">
          <div class="col">
            <mat-card class="p-3 bg-white">$bg-white</mat-card>
          </div>
          <div class="col">
            <mat-card class="p-3 bg-light">$bg-light</mat-card>
          </div>
          <div class="col">
            <mat-card class="p-3 bg-light-grey">$light-grey / $border-color</mat-card>
          </div>
          <div class="col">
            <mat-card class="p-3 bg-grey">$grey / $status-na</mat-card>
          </div>
          <div class="col">
            <mat-card class="p-3 bg-dark-grey">$dark-grey</mat-card>
          </div>
          <div class="col">
            <mat-card class="p-3 bg-black">$black / $body-color</mat-card>
          </div>
        </div>
        <h4>Semantic colors</h4>
        <div class="row mb-3">
          <div class="col">
            <mat-card class="p-3 bg-success">$success / $status-success</mat-card>
          </div>
          <div class="col">
            <mat-card class="p-3 bg-danger">$danger / $status-rejected</mat-card>
          </div>
          <div class="col">
            <mat-card class="p-3 bg-alert">$alert</mat-card>
          </div>
          <div class="col">
            <mat-card class="p-3 bg-wip">$status-wip</mat-card>
          </div>
        </div>
      </section>

      <section id="typography">
        <h3 class="demo-section-title">Typography</h3>

        <div class="row">
          <div class="col-auto">
            <h1>Heading One (Page Title)</h1>
            <h2>Heading Two</h2>
            <h3>Heading Three (Card Titles)</h3>
            <h4>Heading Four</h4>
            <h5>Heading Five</h5>
            <h6>Heading Six</h6>
          </div>
          <div class="col border-left">
            <div class="row">
              <div class="col-4">
                <h5 class="subtitle text-right">Regular paragraph (with bolded text)</h5>
              </div>
              <div class="col">
                <p>
                  Here is a regular paragraph.
                  <strong>Lorem, ipsum dolor</strong>
                  sit amet consectetur adipisicing elit. Porro consectetur, provident officia harum nihil quis sequi
                  esse pariatur illo expedita saepe vero? Nobis repellendus non inventore unde tenetur quia excepturi.
                </p>
              </div>
            </div>
            <div class="row">
              <div class="col-4">
                <h5 class="subtitle text-right">Regular paragraph with "text-muted" class</h5>
              </div>
              <div class="col">
                <p class="text-muted">
                  Here is a regular faded paragraph.
                  <strong>Lorem, ipsum dolor</strong>
                  sit amet consectetur adipisicing elit. Porro consectetur, provident officia harum nihil quis sequi
                  esse pariatur illo expedita saepe vero?
                </p>
              </div>
            </div>
            <div class="row">
              <div class="col-4">
                <h5 class="subtitle text-right">Small text (with bolded text)</h5>
              </div>
              <div class="col">
                <small>
                  Here is a regular paragraph
                  <strong>width bold (strong) text</strong>
                  . Lorem, ipsum dolor sit amet consectetur adipisicing elit. Porro consectetur, provident officia harum
                  nihil quis sequi esse pariatur illo expedita saepe vero?
                </small>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="icons">
        <h3 class="demo-section-title">Material icons (SVG)</h3>
        <div class="custom-icons-wrapper">
          <mat-icon svgIcon="menu-down"></mat-icon>
          <mat-icon svgIcon="file-pdf"></mat-icon>
          <mat-icon svgIcon="check-circle"></mat-icon>
          <mat-icon svgIcon="clock"></mat-icon>
          <mat-icon svgIcon="alert-circle"></mat-icon>
          <mat-icon svgIcon="alert"></mat-icon>
          <span>See more details in svg-icons.module.ts</span>
        </div>
      </section>

      <section id="gridLayout">
        <h3 class="demo-section-title">Grid layout</h3>

        <h5 class="subtitle">Spacers</h5>
        <div class="row align-items-baseline">
          <div class="col-auto">
            <div class="example-spacer"></div>
            <div class="mt-1">$spacer</div>
          </div>
          <div class="col-auto">
            <div class="example-grid-gutter"></div>
            <div class="mt-1">$grid-gutter</div>
          </div>
          <div class="col-auto">
            <div class="example-small-gutter"></div>
            <div class="mt-1">$small-gutter</div>
          </div>
        </div>

        <br />

        <h5 class="subtitle">Bootstrap Grid</h5>
        <p>
          Dev info: we are using Bootstrap 4 grid with flex and spacing class utilities (like .d-flex,
          .align-items-center, etc / .ml-2, .my-3, .pb-4, .px-5 etc)
        </p>
        <br />
        <p>Default grid example</p>
        <div class="row example-grid mb-3">
          <div class="col-2">
            <div class="col-content">.col-2</div>
          </div>
          <div class="col-4">
            <div class="col-content">.col-4</div>
          </div>
          <div class="col-auto">
            <div class="col-content">.col-auto</div>
          </div>
          <div class="col">
            <div class="col-content">.col</div>
          </div>
        </div>
        <p>Grid example with "small-gutters" class applied belong to the "row" class</p>
        <div class="row small-gutters example-grid mb-3">
          <div class="col-2">
            <div class="col-content">.col-2</div>
          </div>
          <div class="col-4">
            <div class="col-content">.col-4</div>
          </div>
          <div class="col-auto">
            <div class="col-content">.col-auto</div>
          </div>
          <div class="col">
            <div class="col-content">.col</div>
          </div>
        </div>
      </section>

      <section id="innerSections">
        <h3 class="demo-section-title">Inner Sections</h3>

        <h5 class="subtitle">Custom sections with header, body and footer</h5>
        <p>Dev info: For this example we are using a mat-card with "noPadding" class</p>
        <mat-card class="noPadding">
          <div class="section">
            <div class="section_header">
              <span class="section_title">Header title</span>
            </div>
            <div class="section_body">Body</div>
            <div class="section_footer">Footer</div>
          </div>
        </mat-card>

        <br />

        <h5 class="subtitle">Line delimiters</h5>
        <mat-card>
          <span>Default hr element looks like this:</span>
          <hr />
          <span>hr element with custom class "extended" will looks like this:</span>
          <hr class="extended" />
          <span>*asuming the parent element have "$spacer" (1rem / 16px) padding on the left and right sides</span>
        </mat-card>
      </section>

      <section id="forms">
        <h3 class="demo-section-title">Form elements</h3>
        <p>Dev info: All the mat-form-field elements will use 'appearance="fill" attribute'</p>
        <h5 class="subtitle">Material outline form fields</h5>

        <p class="formInlineWrapper">
          <mat-form-field appearance="fill">
            <mat-label>Form label here pqyg</mat-label>
            <input matInput placeholder="Placeholder pqyg" />
            <mat-icon matSuffix svgIcon="alert-circle"></mat-icon>
            <mat-hint>Hint will be here</mat-hint>
          </mat-form-field>

          <mat-form-field appearance="fill">
            <mat-label>
              <span class="globalBadge">Global</span>
              Fancy label pqyg
            </mat-label>
            <input matInput placeholder="Placeholder pqyg" />
          </mat-form-field>

          <mat-form-field appearance="fill">
            <mat-label>Form with long label. This is a veryyyyyy looooong label</mat-label>
            <input matInput placeholder="Placeholder pqyg" />
          </mat-form-field>
        </p>

        <h5 class="subtitle">Material Select (primary use) vs native select</h5>
        <p class="formInlineWrapper">
          <mat-form-field appearance="fill">
            <mat-label>Select pqyg (with floating label)</mat-label>
            <mat-select #select>
              <mat-option [value]="-1">All items</mat-option>
              <mat-option [value]="0">Option One pqyg</mat-option>
              <mat-option [value]="1">Option Two</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="fill">
            <mat-select #select2>
              <mat-option [value]="-1">Select (w/o mat-label)</mat-option>
              <mat-option [value]="0">Option One pqyg</mat-option>
              <mat-option [value]="1">Option Two</mat-option>
              <mat-option [value]="2">Option Three</mat-option>
            </mat-select>
          </mat-form-field>
        </p>

        <h5 class="subtitle">Textarea with mat-label</h5>
        <mat-form-field appearance="fill">
          <mat-label>Textarea label STR gjy</mat-label>
          <textarea matInput placeholder="Optional placeholder"></textarea>
        </mat-form-field>

        <h5 class="subtitle">Checkboxes</h5>
        <p class="formInlineWrapper">
          <mat-checkbox color="primary">Primary check</mat-checkbox>
        </p>

        <br />

        <h5 class="subtitle">Custom inline forms</h5>
        <p>Dev info: wrap all the elements with a "formInlineWrapper" class</p>
        <div class="formInlineWrapper">
          <mat-form-field appearance="fill">
            <mat-label>Abcdef STR</mat-label>
            <input matInput />
          </mat-form-field>
          <mat-form-field appearance="fill">
            <mat-label>pqygtf</mat-label>
            <input matInput />
          </mat-form-field>
          <button mat-icon-button color="primary">
            <mat-icon svgIcon="plus"></mat-icon>
          </button>
          <button mat-button color="primary">Text Button</button>
        </div>
      </section>

      <section id="buttons">
        <h3 class="demo-section-title">Buttons</h3>
        <p>
          Dev info: when two or more buttons will be on the same line, wrap them in "buttonsWrapper" class or add
          "@extend .buttonsWrapper" for the parent element in scss
        </p>
        <br />

        <h5 class="subtitle">Material buttons (primary use)</h5>
        <div class="buttonsWrapper">
          <button mat-flat-button color="primary">Flat button primary</button>
          <button mat-flat-button class="mat-secondary">Flat button secondary</button>
          <button mat-flat-button color="success">Flat button success</button>
          <button mat-flat-button color="warn">Flat button warn</button>
          <button mat-flat-button class="mat-secondary-danger">Flat button secondary danger</button>
        </div>

        <br />
        <br />

        <h5 class="subtitle">Material buttons with borders (secondary use), text buttons and icon buttons</h5>
        <div class="buttonsWrapper">
          <button mat-stroked-button color="primary">Stroked button primary</button>
          <button mat-stroked-button color="warn">Stroked button warn</button>
          <button mat-button color="primary">Text button primary</button>
          <button mat-icon-button color="primary">
            <mat-icon svgIcon="plus"></mat-icon>
          </button>
          <button mat-icon-button color="warn">
            <mat-icon svgIcon="delete-forever"></mat-icon>
          </button>
          <button mat-icon-button>
            <mat-icon svgIcon="close"></mat-icon>
          </button>
        </div>

        <br />
        <br />

        <h3>Smaller Buttons</h3>
        <p>Dev info: add class "button--small"</p>

        <h5 class="subtitle">Small Material buttons (primary use)</h5>
        <div class="buttonsWrapper">
          <button mat-flat-button class="button--small" color="primary">Flat button primary</button>
          <button mat-flat-button class="button--small" color="success">Flat button success</button>
          <button mat-flat-button class="button--small" color="warn">Flat button warn</button>
        </div>

        <br />
        <br />

        <h5 class="subtitle">Small Material buttons with borders (secondary use), text buttons and icon buttons</h5>
        <div class="buttonsWrapper">
          <button mat-stroked-button class="button--small" color="primary">Stroked button primary</button>
          <button mat-stroked-button class="button--small" color="warn">Stroked button warn</button>
          <button mat-button class="button--small" color="primary">Text button primary</button>
        </div>

        <br />
        <br />

        <h5 class="subtitle">Extended material buttons: square buttons, buttons whith icons and text</h5>
        <div class="buttonsWrapper">
          <button mat-flat-button class="button--square">
            <mat-icon svgIcon="dots-horizontal"></mat-icon>
          </button>
          <button color="warn" mat-stroked-button class="button--square">
            <mat-icon svgIcon="delete-forever"></mat-icon>
          </button>
          <button mat-stroked-button color="primary">
            <mat-icon svgIcon="chevron-left"></mat-icon>
            Previous
          </button>
          <button mat-flat-button color="primary">
            Next
            <mat-icon class="iconRight" svgIcon="chevron-right"></mat-icon>
          </button>
        </div>
      </section>
    </div>

    <div class="col-md-auto">
      <div class="position-sticky">
        <h4>Table of contents</h4>
        <p>Material UI customized</p>
        <a class="d-block py-2" href="/style-guide#colors">Colors</a>
        <a class="d-block py-2" href="/style-guide#typography">Typography</a>
        <a class="d-block py-2" href="/style-guide#icons">Icons</a>
        <a class="d-block py-2" href="/style-guide#forms">Forms</a>
        <a class="d-block py-2" href="/style-guide#buttons">Buttons</a>
        <br />
        <br />
        <p>Layout</p>
        <a class="d-block py-2" href="/style-guide#gridLayout">Grid Layout</a>
        <a class="d-block py-2" href="/style-guide#innerSections">Inner sections</a>
        <br />
        <br />
      </div>
    </div>
  </div>
</div>
